<div class="overflow-x-hidden flex flex-col w-full h-full">
    <div class="flex flex-grow flex-shrink basis-[calc(100%-80px)] min-h-[calc(100%-80px)]">
        <app-map [embed]="true"></app-map>
    </div>
</div>
